import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { KpiConfigurationComponent } from './kpi-configuration/kpi-configuration.component';



@NgModule({
  declarations: [KpiConfigurationComponent],
  imports: [
    CommonModule,SharedModule
  ],
  exports: [KpiConfigurationComponent]
})
export class DashboardReportsModule { }
